<div class="modal-header">
  <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
    <span aria-hidden="true">×</span>
  </button>
  <h5 class="modal-title w-100 d-flex justify-content-center" id="myModalLabel">{{heading}}</h5>
</div>
<div class="modal-body">
  <textarea type="text" class="md-textarea md-textarea-auto form-control" mdbInput [value]="text" readonly></textarea>
</div>
